import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')

// 页面列表検索
export const search = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_laberNoticeInfo + '?' + querys)
}
//文件查询
export const b_0002_getFile = (params) => {
  return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(params.filePath) + '&resizeCd=' + params.resizeCd)
}
// 労働条件通知書PDF検索
export const getLaborNoticeOutput = (params) => {
  let querys = querystring.stringify(params)
  return http.requestPostZip(apiUrl.apiUrl_laborNoticeOutput + '?' + querys)
}



// WEBPACK FOOTER //
// ./src/module/api/c_0003.js